export default "__VITE_PUBLIC_ASSET__30751e94__"